import { Component, input, output } from '@angular/core';

import { Theme } from '../../../core/models/responses/theme';
import { BackButton } from '../back-button/back-button';
import { PageLoader } from '../page-loader/page-loader';
import { ThemeCard } from '../theme-card/theme-card';

/**
 * Layout de escolha de tema (título, grade de temas e botão voltar), sem saber
 * de modo de jogo: cada tela de modo (Solo, Desafio Diário) decide o que fazer
 * em `themeSelect`.
 */
@Component({
  selector: 'app-theme-picker',
  imports: [ThemeCard, PageLoader, BackButton],
  templateUrl: './theme-picker.html',
  styleUrl: './theme-picker.scss',
})
export class ThemePicker {
  readonly title = input.required<string>();
  readonly themes = input.required<Theme[]>();
  readonly isLoading = input(false);

  readonly themeSelect = output<Theme>();
  readonly back = output<void>();
}
